import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { makeStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import SaveIcon from '@material-ui/icons/Save';
import { showSpinner, hideSpinner } from '../../reducers/UiReducer';
import { handleError } from '../../reducers/ErrorReducer';
import { notify } from '../../reducers/NotifierReducer';
import TextField from '@material-ui/core/TextField';

import Grid from '@material-ui/core/Grid';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import {
  testEmail,
  testSMS,
  savePagingSettings,
  getPagingSettings,
  getFireHornSetting,
  sendTofireHornAPI,
  removeAssignedRecipient,
  getFireHornAssignAgencycounts,
  getPTSAssignAgencycounts,
  getPTSConnectSetting,
  sendToPTSConnectAPI,
  removePTSAssignedRecipient
} from '../../reducers/PagingReducer';
import { validateEmail } from '../../utils/functions';
import { CircularProgress } from '@material-ui/core';
import EditIcon from '@material-ui/icons/Edit';
import options from 'components/IconsAgency';
import { getService } from 'reducers/service';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import Check from '@material-ui/icons/Check';

function getFormStyle(minWidth, maxWidth) {
  return {
    maxWidth: maxWidth,
    flexBasis: minWidth,
    minWidth: minWidth,
    flexGrow: 1,
    margin: `0 4px 8px`,
  };
}

const useStyles = makeStyles(theme => ({
  root: {
    width: '100%',
    '& h4': {
      marginBottom: theme.spacing(2),
      overflow: 'hidden',
    },
  },
  table: {
    minWidth: 150,
    maxWidth: 200,
    '& td': {
      paddingTop: 2,
      paddingBottom: 2,
    },
  },
  actions: {
    //textAlign: 'right',
    marginTop: 30,
    '& button': {
      '& svg': {
        marginRight: theme.spacing(1),
      },
    },
  },
  form: {
    margin: `0 -${theme.spacing(0.5)}px`,
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: 'center',
    width: '100%',
    maxWidth: 400,
  },
  emailTest: {
    margin: `0 -${theme.spacing(0.5)}px`,
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: 'center',
    width: '100%',
    maxWidth: 400,
    justifyContent: 'space-between',
    '& button': {
      marginBottom: theme.spacing(1),
    },
  },
  radioGroup: {
    width: '100%',
  },
  textField: {
    ...getFormStyle(200, 300),
  },
  testField: {
    ...getFormStyle(200, 300),
  },
  w100pr: {
    width: '100%',
    marginBottom: theme.spacing(1),
  },
  checkbox: {
    // margin: `-${theme.spacing(0.5)}px ${theme.spacing(0.5)}px 0`,
  },
  loading: {
    textAlign: 'center',
    zIndex: 9999,
    position: 'absolute',
    top: '40%',
    left: '40%',
  },
  centerCell: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  badge: {
    minWidth: '60px',
    padding: '6px 14px',
    borderRadius: '20px',
    fontWeight: 600,
    textAlign: 'center',
  },
  progressWrapper: {
    width: '80%',
    height: '8px',
    backgroundColor: '#e0e0e0',
    borderRadius: '6px',
    overflow: 'hidden',
  },
}));

const iconRender = params => {
  const Icon = options[params.value];
  return Icon ? <Icon /> : ' ';
};

const getProgressColor = percentage => {
  if (percentage >= 100) return '#d32f2f';
  if (percentage >= 80) return '#f57c00';
  return '#2e7d32';
};

function SMTPSettings(props) {
  const classes = useStyles();
  const [sendgridFrom, setSendgridFrom] = useState('');
  const [sendgridKey, setSendgridKey] = useState('');
  const [emailTo, setEmailTo] = useState('');
  const [twilioSid, setTwilioSid] = useState('');
  const [twilioKey, setTwilioKey] = useState('');
  const [twilioMsgSSid, setTwilioMsgSSid] = useState('');
  const [phoneNo, setPhoneNo] = useState('');
  const [smtpValid, setSmtpValid] = useState(false);
  const [loading, setLoading] = useState(false);
  const { dataUpdate } = props;
  const service = getService('cad-search-agencies');
  const cdrService = getService('settings-agency-cad');
  const [rows, setRows] = useState([]);
  const [filteredRows, setFilteredRows] = useState([]);
  const [selection, setselection] = useState(null);
  const [openDialog, setOpenDialog] = useState(false);  
  //Firehorn
  const [fireHornEnabled, setFireHornEnabled] = useState(false);
  const [fireHornAgencyId, setFireHornAgencyId] = useState('');
  const [fireHornSetting, setFireHornSetting] = useState(null);
  const [fireHornKey, setFireHornKey] = useState('');
  const [isFireHornSaveDisabled, setIsFireHornSaveDisabled] = useState(null);
  const [totalRecipients, setTotalRecipients] = useState('');
  const [totalRecipientsLimit, setTotalRecipientsLimit] = useState(0);
  const [numberOfRecipients, setNumberOfRecipients] = useState(0);
  const [numberOfRecipientsError, setNumberOfRecipientsError] = useState(false);
  const [totalRecipientsLimitError, setTotalRecipientsLimitError] = useState('');
  const [assignedLicenses, setAssignedLicenses] = useState(null);
  
  //PTS-Connect
  const [ptsConnectEnabled, setPtsConnectEnabled] = useState(false);
  const [ptsConnectAgencyId, setPtsConnectAgencyId] = useState('');
  const [ptsSetting, setPTSSetting] = useState(null);
  const [ptsConnectKey, setPtsConnectKey] = useState('');
  const [ptsTotalRecipients, setPtsTotalRecipients] = useState(0);
  const [ptsTotalRecipientsLimit, setPtsTotalRecipientsLimit] = useState(0);
  const [ptsNumberOfRecipients, setPtsNumberOfRecipients] = useState(0);
  const [ptsNumberOfRecipientsError, setPtsNumberOfRecipientsError] = useState(false);
  const [ptsTotalRecipientsLimitError, setPtsTotalRecipientsLimitError] = useState('');
  const [ptsAssignedLicenses, setPtsAssignedLicenses] = useState(null);

  const [isSaveDisabled, setIsSaveDisabled] = useState(null);
  
  //get agency data
  useEffect(() => {
    getAgencyData();
  }, []);
  
  //update agency data
  useEffect(() => {
    if (dataUpdate && dataUpdate.type === 'agencies') getAgencyData();
  }, [dataUpdate]);

  //dialog check limit and set error and disable save
  useEffect(() => {
    const validate = ({
      enabled,
      value,
      setError,
      setting,
      totalLimit,
      assigned = 0,
    }) => {
      if (!enabled) {
        setError(false);
        return false;
      }
  
      const input = Number(value || 0);
  
      if (!input || input <= 0) {
        setError('This field is required.');
        return true;
      }
  
      if (input < assigned) {
        setError('Limit cannot be lower than already assigned licenses.');
        return true;
      }
  
      const otherTotal =
        setting
          ?.filter(a => a.agency.toLowerCase() !== selection.toLowerCase())
          .reduce((sum, a) => sum + Number(a.noofrecipient || 0), 0) || 0;
  
      if (otherTotal + input > totalLimit) {
        setError('Total licenses limit exceeded.');
        return true;
      }
  
      setError(false);
      return false;
    };
  
    const fireHornInvalid = validate({
      enabled: fireHornEnabled,
      value: numberOfRecipients,
      setError: setNumberOfRecipientsError,
      setting: fireHornSetting,
      totalLimit: totalRecipientsLimit,
      assigned: assignedLicenses?.[selection?.toLowerCase()] ?? 0,
    });
  
    const ptsInvalid = validate({
      enabled: ptsConnectEnabled,
      value: ptsNumberOfRecipients,
      setError: setPtsNumberOfRecipientsError,
      setting: ptsSetting,
      totalLimit: ptsTotalRecipientsLimit,
      assigned: ptsAssignedLicenses?.[selection?.toLowerCase()] ?? 0,
    });
  
    setIsFireHornSaveDisabled(fireHornInvalid || ptsInvalid);
  }, [
    fireHornEnabled,
    numberOfRecipients,    
    selection,
    totalRecipientsLimit,
    assignedLicenses,
    ptsAssignedLicenses,
    ptsConnectEnabled,
    ptsNumberOfRecipients,
    ptsSetting,
    ptsTotalRecipientsLimit,  
  ]);
  
  useEffect(() => {
    const isInvalid =
      totalRecipientsLimit < totalRecipients || ptsTotalRecipientsLimit < ptsTotalRecipients;
    setTotalRecipientsLimitError(totalRecipientsLimit < totalRecipients);
    setPtsTotalRecipientsLimitError(ptsTotalRecipientsLimit < ptsTotalRecipients);
    setIsSaveDisabled(isInvalid);
  }, [totalRecipientsLimit, totalRecipients, ptsTotalRecipientsLimit, ptsTotalRecipients]);

  const getAgencyData = async () => {
    const [data, fireHornSetting, ptsSetting, recipientsRes] = await Promise.all([
      service.find({ query: { originSettings: true } }),
      getFireHornSetting(),
      getPTSConnectSetting(),
      getService('pagrecipient').find({
        query: { IsDeleted: false, $sort: { Created: -1 }, $limit: 0 },
      }),
    ]);
  
    const recipients = recipientsRes?.data || [];
  
    // totals
    const totalRecipients = fireHornSetting.reduce((s, x) => s + Number(x.noofrecipient || 0), 0);
    const ptsTotalRecipients = ptsSetting.reduce((s, x) => s + Number(x.noofrecipient || 0), 0);
  
    // assigned
    const assigned = getFireHornAssignAgencycounts(recipients);
    const ptsAssigned = getPTSAssignAgencycounts(recipients);
  
    // set state
    setFireHornSetting(fireHornSetting);
    setPTSSetting(ptsSetting);
    setTotalRecipients(totalRecipients);
    setPtsTotalRecipients(ptsTotalRecipients);
    setAssignedLicenses(assigned);
    setPtsAssignedLicenses(ptsAssigned);
  
    setRows(processData(data, fireHornSetting, assigned, ptsSetting, ptsAssigned));
  };

  const processData = (data, fireHornSetting, assigned, ptsSetting, ptsAssigned) =>
    (data || [])
      .filter(x => !x?.IsDeleted)
      .map(row => {
        const id = row.AgencyID?.toLowerCase() || '';
  
        const fh = fireHornSetting.find(x => x.agency?.toLowerCase() === id) || {};
        const pts = ptsSetting.find(x => x.agency?.toLowerCase() === id) || {};
  
        const fhTotal = Number(fh.noofrecipient) || 0;
        const ptsTotal = Number(pts.noofrecipient) || 0;
  
        const fhUsed = assigned[id] ?? 0;
        const ptsUsed = ptsAssigned[id] ?? 0;
  
        return {
          ...row,
          id: row.AgencyID,
  
          fireHornEnable: fh.enable || false,
          fireHornNoofrecipient: fhTotal,
          fireHornAgencyId: fh.agencyId || '',
          usedLicense: fhUsed,
          remainingLicense: fhTotal - fhUsed,
  
          ptsConnectEnable: pts.enable || false,
          ptsConnectNoofrecipient: ptsTotal,
          ptsConnectAgencyId: pts.agencyId || '',
          ptsUsedLicense: ptsUsed,
          ptsRemainingLicense: ptsTotal - ptsUsed,
        };
      });

  useEffect(() => {
    getSettings();
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    validateSMTP();
    // eslint-disable-next-line
  }, [sendgridFrom, sendgridKey, emailTo]);

  const getSettings = async () => {
    props.showSpinner();
    try {
      const settings = await getPagingSettings();
      const {
        sendgridKey,
        sendgridFrom,
        twilioSid,
        twilioKey,
        twilioMsgSSid,
        fireHornKey,
        totalRecipientsLimit,
        ptsConnectKey,
        ptsTotalRecipientsLimit
      } = settings;
      setSendgridFrom(sendgridFrom);
      setSendgridKey(sendgridKey);
      setTwilioKey(twilioKey);
      setFireHornKey(fireHornKey);
      setTwilioSid(twilioSid);
      setTwilioMsgSSid(twilioMsgSSid);
      setTotalRecipientsLimit(totalRecipientsLimit);
      setPtsConnectKey(ptsConnectKey || '');
      setPtsTotalRecipientsLimit(ptsTotalRecipientsLimit || 0);
    } catch (err) {
      props.handleError(err, 'Error, cannot load settings.');
    }
    props.hideSpinner();
  };

  const validateSMTP = () => {
    let valid = true;
    if (!sendgridFrom || !sendgridKey || !emailTo) valid = false;
    if (sendgridFrom && !validateEmail(sendgridFrom)) valid = false;
    if (emailTo && !validateEmail(emailTo)) valid = false;
    valid !== smtpValid && setSmtpValid(valid);
  };

  const save = async () => {
    const data = {
      sendgridFrom,
      sendgridKey,
      twilioKey,
      twilioSid,
      twilioMsgSSid,
      fireHornKey,
      totalRecipientsLimit,
      ptsConnectKey,
      ptsTotalRecipientsLimit
    };
    props.showSpinner();
    try {
      await savePagingSettings(data);
      props.notify('Settings saved', 'success');
    } catch (err) {
      props.handleError(err, 'Error, settings not saved');
    }
    props.hideSpinner();
  };

  const onTestEmail = async () => {
    const mail = {
      sendgridFrom,
      sendgridKey,
      Subject: 'E-mail test from CAD app',
      Body: 'Your CAD email service has been setup correctly.',
      emailTo,
    };
    props.showSpinner();
    try {
      await testEmail(mail);
      props.notify('E-mail has been sent, please check you mailbox.');
    } catch (err) {
      props.notify('Error, e-mail not sent', 'error');
      console.log(err);
    }
    props.hideSpinner();
  };

  const onTestSMS = async () => {
    const mail = {
      twilioKey,
      twilioSid,
      twilioMsgSSid,
      twilioTo: phoneNo,
      Body: 'Your CAD SMS service has been setup correctly.',
    };
    props.showSpinner();
    try {
      await testSMS(mail);
      props.notify('E-mail has been sent, please check you mailbox.');
    } catch (err) {
      props.notify('Error, e-mail not sent', 'error');
      console.log(err);
    }
    props.hideSpinner();
  };

  const renderSendgridSettings = () => {
    return (
      <div className={classes.form}>
        <TextField
          className={classes.w100pr}
          label="E-mail From"
          value={sendgridFrom}
          onChange={ev => setSendgridFrom(ev.target.value)}
          variant="outlined"
          size="small"
        />
        <TextField
          className={classes.w100pr}
          label="Sendgrid key"
          value={sendgridKey}
          onChange={ev => setSendgridKey(ev.target.value)}
          variant="outlined"
          size="small"
          type="password"
          inputProps={{
            autoComplete: 'new-password',
            form: { autoComplete: 'off' },
          }}
        />
      </div>
    );
  };

  const renderTwilioSettings = () => {
    return (
      <div className={classes.form}>
        <TextField
          className={classes.w100pr}
          label="Message Service SID"
          value={twilioMsgSSid}
          onChange={ev => setTwilioMsgSSid(ev.target.value)}
          variant="outlined"
          size="small"
        />
        <TextField
          className={classes.w100pr}
          label="Account SID"
          value={twilioSid}
          onChange={ev => setTwilioSid(ev.target.value)}
          variant="outlined"
          size="small"
        />
        <TextField
          className={classes.w100pr}
          label="Twilio Auth Token"
          value={twilioKey}
          onChange={ev => setTwilioKey(ev.target.value)}
          variant="outlined"
          size="small"
          type="password"
          inputProps={{
            autoComplete: 'new-password',
            form: { autoComplete: 'off' },
          }}
        />
      </div>
    );
  };

  const renderPTSConnectSettings = () => {
    return (
      <div className={classes.form}>
        <TextField
          className={classes.w100pr}
          label="Vocal Auth Token"
          value={ptsConnectKey}
          onChange={e => setPtsConnectKey(e.target.value)}
          variant="outlined"
          size="small"
          type="password"
        />
  
        <TextField
          className={classes.w100pr}
          label="Total Available License"
          value={ptsTotalRecipientsLimit}
          onChange={e => {
            const value = e.target.value;
            if (/^\d*$/.test(value)) {
              setPtsTotalRecipientsLimit(value);
            }
          }}
          variant="outlined"
          size="small"          
          error={ptsTotalRecipientsLimitError}
          helperText={
            ptsTotalRecipientsLimitError ? 'Total licenses cannot be less than assigned License.' : ''
          }
        />
  
        <h6 style={{ marginLeft: 4 }}>
          Assigned: {ptsTotalRecipients} | Available:
          {ptsTotalRecipientsLimit - ptsTotalRecipients}
        </h6>
      </div>
    );
  };

  const renderFireHornSettings = () => {
    return (
      <div className={classes.form}>
        <TextField
          className={`${classes.w100pr}`}
          label="Firehorn Auth Token"
          value={fireHornKey}
          onChange={ev => setFireHornKey(ev.target.value)}
          variant="outlined"
          size="small"
          type="password"
        />
        <TextField
          className={`${classes.w100pr}`}
          label="Total Available License"
          value={totalRecipientsLimit}
          onChange={ev => {
            const value = ev.target.value;
            if (/^\d*$/.test(value)) {
              setTotalRecipientsLimit(value);
            }
          }}
          variant="outlined"
          size="small"
          error={totalRecipientsLimitError}
          helperText={
            totalRecipientsLimitError ? 'Total licenses cannot be less than assigned License.' : ''
          }
        />
        <h6 style={{ marginLeft: 4, fontSize: '0.9rem', color: '#3f3f3f' }}>
          Assigned: {totalRecipients} | Available:
          {totalRecipientsLimit - totalRecipients}
        </h6>
      </div>
    );
  };

  const renderEmailTest = () => {
    return (
      <div className={classes.emailTest}>
        <TextField
          className={classes.testField}
          label="E-mail"
          value={emailTo}
          onChange={ev => setEmailTo(ev.target.value)}
          variant="outlined"
          size="small"
        />
        <div className={classes.btnWrap}>
          <Button variant="contained" color="primary" onClick={onTestEmail} disabled={!smtpValid}>
            Test
          </Button>
        </div>
      </div>
    );
  };

  const renderSMSTest = () => {
    return (
      <div className={classes.emailTest}>
        <TextField
          className={classes.testField}
          label="+1 xxx xxx xxx xxx"
          value={phoneNo}
          onChange={ev => setPhoneNo(ev.target.value)}
          variant="outlined"
          size="small"
        />
        <div className={classes.btnWrap}>
          <Button
            variant="contained"
            color="primary"
            onClick={onTestSMS}
            disabled={!twilioSid || !twilioKey || !twilioMsgSSid || !phoneNo}>
            Test
          </Button>
        </div>
      </div>
    );
  };

  const gridStyle = {
    display: 'grid',
    gridTemplateColumns: '180px 80px 60px 60px 260px 100px 60px 60px 260px 60px',
    gap: '40px',
  };
  
  const getBadgeStyle = p => ({
    backgroundColor: p >= 100 ? '#ffebee' : p >= 80 ? '#fff3e0' : '#e8f5e9',
    color: p >= 100 ? '#d32f2f' : p >= 80 ? '#f57c00' : '#2e7d32',
  });
  
  const renderCustomTable = () => (
    <div style={{ border: '1px solid #ddd', borderRadius: 10, overflow: 'hidden' }}>
      <div style={{ overflowX: 'auto', maxHeight: '450px' }}>
        
        {/* Header */}
        <div style={{ ...gridStyle, background: '#f5f5f5', padding: 12, fontWeight: 600 }}>
          {[
            'Agency', 'FireHorn', 'Total Lic.', 'Used Lic.', 'Remaining Licence',
            'Vocal', 'Total Lic.', 'Used Lic.', 'Remaining Licence', 'Action'
          ].map(h => <div key={h}>{h}</div>)}
        </div>
  
        {(filteredRows.length ? filteredRows : rows).map(renderRow)}
      </div>
    </div>
  );
  
  const renderRow = row => {
    const fhMax = row.fireHornNoofrecipient || 0;
    const fhUsed = row.usedLicense || 0;
    const fhPerc = fhMax ? (fhUsed / fhMax) * 100 : 0;
  
    const ptsMax = row.ptsConnectNoofrecipient || 0;
    const ptsUsed = row.ptsUsedLicense || 0;
    const ptsPerc = ptsMax ? (ptsUsed / ptsMax) * 100 : 0;
  
    const Progress = (perc, used, max) => (
      <>
        <div style={{ height: 8, background: '#e0e0e0', borderRadius: 6, overflow:'hidden' }}>
          <div style={{
            width: `${Math.min(perc, 100)}%`,
            height: '100%',
            background: getProgressColor(perc)
          }} />
        </div>
        <div style={{ fontSize: 11, marginTop: 4 }}>
          {max - used >= 0 ? `${max - used} left (${used}/${max})` : `Over (${used}/${max})`}
        </div>
      </>
    );
  
    return (
      <div key={row.id} style={{ ...gridStyle, padding: 12, borderTop: '1px solid #eee', alignItems: 'center' }}>
        
        <div>{row.AgencyID}</div>
  
        <div>{row.fireHornEnable && <Check style={{ color: '#2e7d32' }} />}</div>
  
        <div className={classes.centerCell}>
          <div className={classes.badge} style={getBadgeStyle(fhPerc)}>{fhMax}</div>
        </div>
  
        <div className={classes.centerCell}>
          <div className={classes.badge} style={getBadgeStyle(fhPerc)}>{fhUsed}</div>
        </div>
  
        <div>{Progress(fhPerc, fhUsed, fhMax)}</div>
  
        <div>{row.ptsConnectEnable && <Check style={{ color: '#2e7d32' }} />}</div>
  
        <div className={classes.centerCell}>
          <div className={classes.badge} style={getBadgeStyle(ptsPerc)}>{ptsMax}</div>
        </div>
  
        <div className={classes.centerCell}>
          <div className={classes.badge} style={getBadgeStyle(ptsPerc)}>{ptsUsed}</div>
        </div>
  
        <div>{Progress(ptsPerc, ptsUsed, ptsMax)}</div>
  
        <div style={{ cursor: 'pointer', display: 'flex', justifyContent: 'center' }}
             onClick={() => handleSelection(row.id)}>
          <EditIcon />
        </div>
  
      </div>
    );
  };

  const formatSaveData = (fhAgencyId, pcAgencyId) => {
    const data = [];  
    if (fhAgencyId) {
      data.push(
        {
          Path: `${selection}.CAD.FireHorn.Enable`,
          CDRKey: 'CAD FireHorn',
          ValueBoolean: fireHornEnabled,
        },
        {
          Path: `${selection}.CAD.FireHorn.NumberOfRecipients`,
          CDRKey: 'CAD FireHorn',
          ValueString: fireHornEnabled ? numberOfRecipients?.toString() ?? '' : '',
        },
        {
          Path: `${selection}.CAD.FireHorn.AgencyId`,
          CDRKey: 'CAD FireHorn',
          ValueString: fhAgencyId,
        }
      );
    }  
    if (pcAgencyId) {
      data.push(
        {
          Path: `${selection}.CAD.PTSConnect.Enable`,
          CDRKey: 'CAD PTSConnect',
          ValueBoolean: ptsConnectEnabled,
        },
        {
          Path: `${selection}.CAD.PTSConnect.NumberOfRecipients`,
          CDRKey: 'CAD PTSConnect',
          ValueString: ptsConnectEnabled ? ptsNumberOfRecipients?.toString() ?? '' : '',
        },
        {
          Path: `${selection}.CAD.PTSConnect.AgencyId`,
          CDRKey: 'CAD PTSConnect',
          ValueString: pcAgencyId,
        }
      );
    }  
    return data;
  };

  const handleSelection = newSelection => {
    setselection(newSelection);
    var data = rows.find(x => x.id.toLowerCase() === newSelection.toLowerCase());
    if (data) {
      setFireHornEnabled(data.fireHornEnable);
      setNumberOfRecipients(parseInt(data.fireHornNoofrecipient, 10) || 0);
      setFireHornAgencyId(data.fireHornAgencyId);
      setPtsConnectEnabled(data.ptsConnectEnable);
      setPtsNumberOfRecipients(parseInt(data.ptsConnectNoofrecipient, 10) || 0);
      setPtsConnectAgencyId(data.ptsConnectAgencyId);
    } else {
      setFireHornEnabled(false);
      setNumberOfRecipients(0);
      setFireHornAgencyId('');
      setPtsConnectEnabled(false);
      setPtsNumberOfRecipients(0);
      setPtsConnectAgencyId('')
    }
    setOpenDialog(true);
  };

  const handleSave = async () => {
    let fhAgencyId = '';
    let pcAgencyId = '';
    try {
      setLoading(true);

      //Firehorn
      const fhAgencies = await sendTofireHornAPI('GET', 'agencies');
      const fhMatch = fhAgencies?.agency?.find(
        a => a.agency_uuid === fireHornAgencyId || a.name === selection
      );
      if (fhMatch) {
        fhAgencyId = fhMatch.agency_uuid;
        if (
          (fireHornEnabled && fhMatch.active === 'inactive') ||
          (!fireHornEnabled && fhMatch.active === 'active')
        ) {
          const apiUrl = `agencies/${fhAgencyId}/${fireHornEnabled ? 'reactivate' : 'deactivate'}`;
          await sendTofireHornAPI('PATCH', apiUrl, null);
        }
      } else if (fireHornEnabled) {
        const fhagency = await sendTofireHornAPI('POST', 'agencies', {
          Agency_Name: selection,
        });
  
        if (fhagency?.agency?.length > 0) {
          fhAgencyId = fhagency.agency[0].new_uuid;
          setFireHornAgencyId(fhAgencyId);
        }
      }

      //PTS-Connect
      const ptsAgencies = await sendToPTSConnectAPI('POST', 'group/list');
      const ptsMatch = ptsAgencies.groups.find(
        a => a.agency_uuid === ptsConnectAgencyId || a.name === selection
      );
      if(ptsMatch){
        pcAgencyId  = ptsMatch.agency_uuid;
        if(!ptsConnectEnabled)
         {
           await sendToPTSConnectAPI('POST', 'group/delete', {
            group: ptsMatch.name,
          });   
         }
      }
      else if (ptsConnectEnabled) {
        const pcagency = await sendToPTSConnectAPI('POST', 'group/create', {
          group: selection,
          name: selection,
        });   
        if (pcagency?.result === 'SUCCESS' && pcagency?.group) {
          pcAgencyId = pcagency.group.agency_uuid;
          setPtsConnectAgencyId(pcAgencyId);
        }    
      }
      const saveObj = formatSaveData(fhAgencyId,pcAgencyId);
      if (!fireHornEnabled) {
        removeAssignedRecipient(selection);
      }
      if(!ptsConnectEnabled){
        removePTSAssignedRecipient(selection);
      }
      await cdrService.create(saveObj);
      props.notify('Settings Saved.', 'success');
      setOpenDialog(false);
      getAgencyData();
    } catch (err) {
      props.handleError(err, 'Error Saving Settings.');
    }
    setLoading(false);
  };
  
  return (
    <div className={classes.root}>
      <h4>Setup Credential</h4>
      <Grid container item xs={12} spacing={2}>
        <Grid item xs={3}>
          <h5>E-mail Settings</h5>
          <h6>Sendgrid</h6>
          {renderSendgridSettings()}
          <div className={classes.actions}>
            <Button color="primary" disabled={isSaveDisabled} variant="contained" onClick={save}>
              <SaveIcon /> Save
            </Button>
          </div>
        </Grid>
        <Grid item xs={2}>
          <h5>SMS Settings</h5>
          <h6>Twilio</h6>
          {renderTwilioSettings()}
        </Grid>
        <Grid item xs={2}>
          <h5>SMS Settings</h5>
          <h6>Vocal</h6>
          {renderPTSConnectSettings()}
        </Grid>
        <Grid item xs={2}>
          <h5>SMS Settings</h5>
          <h6>FireHorn</h6>
          {renderFireHornSettings()}
        </Grid>
        <Grid item xs={3}>
          <h5>Test Email and SMS</h5>
          <h6>Test E-mail Service</h6>
          {renderEmailTest()}
          <h6>Test SMS Service</h6>
          {renderSMSTest()}
        </Grid>
      </Grid>
      <hr />
      <h5>Messaging License Managementt</h5>
      {/* {renderAgencyGrid()} */}
      {renderCustomTable()}
      <Dialog open={openDialog} onClose={() => setOpenDialog(false)} maxWidth="sm" fullWidth>
        <DialogTitle>{selection ? selection : 'Agency Settings'}</DialogTitle>
        <DialogContent dividers>
          {loading && (
            <div className={classes.loading}>
              <CircularProgress />
            </div>
          )}
          <FormControlLabel
            label="FireHorn Enabled"
            control={
              <Checkbox
                checked={fireHornEnabled}
                onChange={ev => setFireHornEnabled(ev.target.checked)}
                label="FireHorn Enabled"
              />
            }
          />
          <br />
          <TextField
            className={classes.w100pr}
            label="Number Of License"
            value={numberOfRecipients}
            onChange={ev =>
              setNumberOfRecipients(ev.target.value === '' ? '' : Number(ev.target.value))
            }
            variant="outlined"
            disabled={!fireHornEnabled}
            size="small"
            error={numberOfRecipientsError}
            helperText={numberOfRecipientsError ? numberOfRecipientsError : ''}
            type="number"
            inputProps={{ min: 0 }}
          />
          <br />

          <FormControlLabel
            label="Vocal Enabled"
            control={
              <Checkbox
                checked={ptsConnectEnabled}
                onChange={e => setPtsConnectEnabled(e.target.checked)}
              />
            }
          />

          <TextField
            className={classes.w100pr}
            label="Vocal License"
            value={ptsNumberOfRecipients}
            onChange={e =>
              setPtsNumberOfRecipients(e.target.value === '' ? '' : Number(e.target.value))
            }
            variant="outlined"
            disabled={!ptsConnectEnabled}
            size="small"
            error={ptsNumberOfRecipientsError}
            helperText={ptsNumberOfRecipientsError ? ptsNumberOfRecipientsError : ''}
            type="number"
          />
        </DialogContent>
        <DialogActions>
          <Button
            color="primary"
            variant="contained"
            onClick={handleSave}
            disabled={loading || isFireHornSaveDisabled}>
            <SaveIcon /> Save
          </Button>
          <Button onClick={() => setOpenDialog(false)} color="primary">
            Close
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}

export default connect(null, {
  showSpinner,
  hideSpinner,
  handleError,
  notify,
})(SMTPSettings);
